import { InputAdornment } from "@mui-wrapper";
import { DateField } from "@mui/x-date-pickers-pro";
import { CalendarIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
const HELPER_TEXT_CLASS_NAME = "helper-class";
/** The date text field allows user to type in a date */
export function FaroDateTextField({
  onChange,
  onConfirmed,
  date
}) {
  return <DateField sx={{
    width: "320px",
    height: "34px",
    borderBottom: `2px solid ${PALETTE_VARS.divider}`,
    [`& .${HELPER_TEXT_CLASS_NAME}`]: {
      visibility: "hidden"
    },
    "&:hover": {
      borderBottom: `2px solid ${PALETTE_VARS.text.primary}`,
      [`& .${HELPER_TEXT_CLASS_NAME}`]: {
        visibility: "visible"
      }
    },
    "&:focus-within": {
      borderBottom: `2px solid ${PALETTE_VARS.primary.main}`,
      [`& .${HELPER_TEXT_CLASS_NAME}`]: {
        visibility: "visible"
      }
    },
    justifyContent: "center",
    m: "12px"
  }} variant="standard" value={date} fullWidth autoFocus slotProps={{
    textField: {
      slotProps: {
        input: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          disableUnderline: true,
          startAdornment: <InputAdornment position="start">
                  <CalendarIcon sx={{
              height: "18px",
              color: "text.secondary"
            }} />
                </InputAdornment>,
          endAdornment: <InputAdornment position="end" className={HELPER_TEXT_CLASS_NAME}>
                  <p style={{
              fontSize: "10px"
            }}>Type and press enter</p>
                </InputAdornment>
        }
      }
    }
  }} onChange={onChange} onKeyDown={event => {
    if (event.key === "Enter") {
      onConfirmed(date);
    }
  }} />;
}